export { default as buttonsSet } from './buttonsSet';

export const FILTERS = [
  {
    key: 'all',
    value: 'All'
  },
  {
    key: 'primary',
    value: 'Primary',
  },
  {
    key: 'secondary',
    value: 'Secondary',
  },
  {
    key: 'exceptions',
    value: 'Exceptions',
  },
];

export const FILTERKEYS = {
  'primary'   : 'Primary',
  'secondary' : 'Secondary',
  'exceptions': 'Exceptions',
};



// WEBPACK FOOTER //
// ./src/containers/elements/Buttons/constants/index.js